// extracted by mini-css-extract-plugin
module.exports = {"container":"Showcase_container__3l9c4","screen":"Showcase_screen__2Z5kt"};